import { Button, message, Modal } from 'antd';
import React, { useState } from 'react';
import Scanner from '../../../components/Scanner/Index';
import axios from '../../../util/Api';

const Scan = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  }

  const handleOk = () => {
    setOpen(false);
  }

  const handleScanned = (data) => {
    const url = `/passport/overview?number=${data}`;
    axios.get(url).then(resp => {
      window.location.href = `/violation/create?id=${resp.data.id}`;
    }).catch(err => {
      message.error("Gagal mendapatkan data personel");
    });
  }

  return (
    <>
      <Button type="primary" ghost size="large" block onClick={()=>setOpen(true)}>Scan QR Code</Button>
      <Modal
        title="Scan QR Code"
        visible={open}
        onOk={handleOk}
        onCancel={handleClose}
        footer={null}
      >
        <div className="gx-text-center">
          <Scanner onScan={handleScanned}/>
        </div>
      </Modal>
    </>
  );
}

export default Scan;